import axios from 'axios';

import { API_URL } from './baseApi';

export const settingsApi = {
  getSettings: async () => {
    return await axios.get(`${API_URL}/v3/services/settings`);
  },
};
